import { FC } from "react";
import PayoutsPage from "../payouts/ui/PayoutsPage";
import CollectionsPage from "../collections/ui/CollectionsPage";
import { TabsList } from "../../../components/ui";
import usePayments from "../bloc/usePayments";
import BeneficiaryPage from "../beneficiaries/ui/beneficiaryPage";


const Payments: FC<({})>
    = () => {

        const {
            tabs,
            selectedTab,
            setSelectedTab
        } = usePayments();

        return (
            <div>
                <div className="bg-[#FAFAFA] px-20 border-b">
                    <TabsList
                        data={tabs}
                        activeTab={selectedTab}
                        onChange={(tab, i) => {
                            setSelectedTab(tab.value);
                        }}
                    />
                </div>
                <div>
                    {selectedTab == "PAYOUTS" && <PayoutsPage />}
                    {selectedTab == "COLLECTIONS" && <CollectionsPage />}
                    {selectedTab == 'BENEFICIARIES' && <BeneficiaryPage />}
                </div>
            </div>
        );
    }

export default Payments;